import get from "lodash/get";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import classes from "classnames";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import StarRatingComponent from "Library/react-star-rating-component";
import Select from "react-select";
import { instance } from "../../../../Actions/AxiosInstance";
import { ValidateDropdown } from "../../../../Utils/Validation";
import addressEmployee from "../../../../Assets/Images/languages.svg";
import createstore from "../../../../store";
import EmpLanguageForm from "./EmpLanguageForm";
import If from "../../../../Component/Common/If";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";

class EmpLanguage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speak: false,
      read: false,
      write: false,
      fluency: [],
      languages: [],
      flag: 0,
      skills: [],
      successFlag: false,
      hideButton: false,
      received: false,
      expanded: false,

      languageid: null,
      fluencyid: null,
      selectedfluency: null,
      allmasterlanguage: [],
      selectedlanguage: null,
      isEdit: false,
      defaultmsg: true,
      EditPerticularLanguage: false,

      isbuttonDisabled: false,
      dataReceived: false,
      error: false,
    };
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        dataReceived: false,
      },
      () => {
        this.GetLanguages();
        this.GetAllmasteralllanguage();
        this.GetFluency();
      },
    );
  }

  handleMusicExpandClick = () => {
    this.setState((state) => ({
      expanded: !state.expanded,
      music: "",
      musicgenreid: "",
      employeemusicid: "",
      isEdit: !state.isEdit,
    }));
  };

  UpdateLanguage(selectedlanguage) {
    this.setState({
      selectedlanguage,
      languageid: selectedlanguage.displayvalue,
    });
  }

  Updatefluency = (selectedfluency) => {
    this.setState({ selectedfluency, fluencyid: selectedfluency.displayvalue });
  };

  UpdateLanguageDetails = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  GetAllmasteralllanguage() {
    const URL = "superuser/getallmasterlanguage";
    instance
      .get(URL)
      .then((result) => {
        if (result.data.result) {
          this.setState({
            allmasterlanguage: result.data.result,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetLanguages() {
    const URL = "employee/getempalllanguage";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let languages = [];
        let { defaultmsg } = this.state;
        const flag = result.data.result.length == 0 ? 0 : 1;
        this.setState({
          languages,
          defaultmsg,
          received: true,
          flag,
        });
        result.data.result.length > 0
          ? (languages = result.data.result)
          : (languages = []);
        // this.setState({ languages });
        for (const obj of languages) {
          const tempArray = [];
          if (obj.isread) tempArray.push("Read");
          if (obj.isspeak) tempArray.push("Speak");
          if (obj.iswrite) tempArray.push("Write");
          if (tempArray.length > 1) {
            obj.languageInfo = tempArray.join(", ");
          } else {
            obj.languageInfo = tempArray.join("");
          }
          defaultmsg =
            result.data.result.length <= 0
              ? (defaultmsg = true)
              : (defaultmsg = false);
        }
        this.setState({
          languages,
          defaultmsg,
          dataReceived: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetFluency() {
    instance
      .get("superuser/getmastercode/FluencyType")
      .then((result) => {
        const fluency = result.data.result;
        this.setState({ fluency });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  AddLanguages() {
    this.setState({ isbuttonDisabled: true });
    if (!this.state.selectedlanguage) {
      this.props.enqueueSnackbar("Please Enter Language", { variant: "error" });
      this.setState({ error: true });
    } else if (!this.state.selectedfluency) {
      this.props.enqueueSnackbar("Please Select Fluency", { variant: "error" });
      this.setState({ error: true, isbuttonDisabled: false, isEdit: true });
    } else if (!this.state.read && !this.state.speak && !this.state.write) {
      this.props.enqueueSnackbar("Select atleast one option", {
        variant: "error",
      });
      this.setState({ error: true, isbuttonDisabled: false });
    } else {
      const data = {
        employeelanguageid: this.state.employeelanguageid || null,
        // languageid: this.state.language,
        employeeid: this.state.colleagueid || this.state.employeeid,
        languageid: this.state.languageid,
        fluencyid: this.state.fluencyid,
        isread: this.state.read,
        iswrite: this.state.write,
        isspeak: this.state.speak,
      };

      const URL = "employee/insertupdateemplanguage";
      instance
        .post(URL, data)
        .then((result) => {
          this.setState(
            (state, prevState) => ({
              EditPerticularLanguage: false,
              isEdit: false,
              defaultmsg: false,
              languageid: null,
              selectedlanguage: null,
              fluencyid: null,
              selectedfluency: null,
              read: false,
              write: false,
              speak: false,
              employeelanguageid: null,
              expanded: false,
              flag: 1,
            }),
            () => {
              this.props.enqueueSnackbar("saved successfully", {
                variant: "success",
              });
              this.GetLanguages();
              this.props.UpdateStrength(true);
              this.setState({ isbuttonDisabled: false });
            },
          );
        })
        .catch((error) => {
          this.setState({ isbuttonDisabled: false });
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
    // this.EditLanguages();
  }

  Deleteconfirmation(item) {
    this.setState({ isEdit: "false" });
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",

      action: [
        <Button
          color="inherit"
          size="small"
          onClick={this.DeleteLanguage.bind(this, item)}
        >
          Delete
        </Button>,
        // :this.DeleteEdu.bind(this, item)
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            this.setState({ isEdit: false });
            this.props.closeSnackbar();
          }}
        >
          Dismiss
        </Button>,
      ],
    });
  }

  EditLanguage(item) {
    const selectedlanguage = this.state.allmasterlanguage.find(
      (lang) => lang.displayvalue == item.languageid,
    );
    const selectedfluency = this.state.fluency.find(
      (fluency) => fluency.displayvalue == item.fluencyid,
    );
    this.setState(
      {
        employeelanguageid: item.employeelanguageid,
        fluencyid: item.fluencyid,
        fluencytype: item.fluencytype,
        read: item.isread,
        speak: item.isspeak,
        write: item.iswrite,
        languageid: item.languageid,
        isEdit: true,
        EditPerticularLanguage: true,
        flag: 2,
        selectedlanguage,
        selectedfluency,
      },
      () => {
        if (this.firstElement) this.firstElement.focus();
      },
    );
  }

  DeleteLanguage(item) {
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      data = {};
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    const URL = `/employee/emplanguage/${item.employeelanguageid}`;
    instance
      .post(URL, data)
      .then((result) => {
        this.setState(
          {
            languageid: null,
            selectedlanguage: null,
            fluencyid: null,
            selectedfluency: null,
            read: false,
            write: false,
            speak: false,
            EditPerticularLanguage: false,
          },
          () => {
            this.props.enqueueSnackbar("deleted successfully", {
              variant: "success",
            });
            this.GetLanguages();
            this.props.UpdateStrength(true);
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  SetFlag = (flag) => {
    this.setState({ flag });
  };

  onCreate() {
    this.setState(
      {
        flag: 2,
        languageid: null,
        selectedfluency: null,
        selectedlanguage: null,
        fluencyid: null,
        employeelanguageid: null,
        read: null,
        speak: null,
        write: null,
        isEdit: true,
        EditPerticularLanguage: false,
      },
      () => {
        if (this.firstElement) this.firstElement.focus();
      },
    );
  }

  getIntroView = () => {
    const { hideButton } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            {!hideButton ? (
              <CreateComp
                text="There are 7106 languages in the world. How many do you speak?"
                heading={
                  <FormattedMessage
                    id="LbLanguages"
                    defaultMessage="Languages"
                  />
                }
                onCreate={this.SetFlag.bind(this, 2)}
                imageSrc={addressEmployee}
              />
            ) : (
              <NoRecordFound />
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  getDataView = (languages) => {
    const { hideButton } = this.state;
    return (
      <div className="profile-data-view-page">
        {languages.map((l) => (
          <div>
            <div className="profile-view-block">
              <If condition={!hideButton}>
                <div className="position-rel">
                  <svg
                    className={"address-edit cursour-pointer"}
                    onClick={() => this.EditLanguage(l)}
                    width="24"
                    style={{ marginRight: 40 }}
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                  </svg>
                  <svg
                    className={"address-edit cursour-pointer"}
                    onClick={() => this.Deleteconfirmation(l)}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                    <path fill="none" d="M0 0h24v24H0V0z" />
                  </svg>
                </div>
              </If>
              <div className="width90">
                <div className="position-rel">
                  <div className="address-data">{l.language}</div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{l.fluencytype}</div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{l.languageInfo}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
        {!hideButton && (
          <div>
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.button}
              onClick={this.onCreate.bind(this)}
            >
              <FormattedMessage id="Lbaddmore" defaultMessage="ADD MORE" />
            </Button>
          </div>
        )}
      </div>
    );
  };

  getFormView = (fluencyid) => (
    <div className="emp-from-wrapper imp-dates">
      <div className="form-height">
        <div id="div">
          <div className="custom-form-box profile-language" autoComplete="off">
            <div className="inner-wrapper opaque" tabIndex="0">
              <div className="form-group">
                <p className="input-form-label">
                  <FormattedMessage
                    id="LbLanguageName"
                    defaultMessage="Language name"
                  />
                </p>
                <Select
                  ref={(r) => {
                    this.firstElement = r;
                  }}
                  id="language-field"
                  defaultValue="Enter Language"
                  className="selectsearch Language1"
                  options={this.state.allmasterlanguage}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.UpdateLanguage.bind(this)}
                  value={this.state.selectedlanguage}
                />
              </div>
              <div className="form-group" tabIndex="11">
                <p className="input-form-label">
                  <FormattedMessage
                    id="LbFluencyType"
                    defaultMessage="Select Fluency"
                  />
                </p>
                <Select
                  className="selectsearch fluency"
                  onChange={this.Updatefluency}
                  options={this.state.fluency}
                  getOptionLabel={(o) => o.displayname}
                  getOptionValue={(o) => o.displayvalue}
                  value={this.state.selectedfluency}
                  placeholder="Select fluency type"
                />
              </div>
              <div className="form-group" align="left">
                <p className="input-form-label">
                  <FormattedMessage
                    id="LbFluencyIn"
                    defaultMessage="Fluent In"
                  />
                </p>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="LbRead"
                      checked={this.state.read}
                      onChange={this.UpdateLanguageDetails("read")}
                      value={this.state.read}
                      classes={{
                        root: classes.root,
                        checked: classes.checked,
                      }}
                      color="primary"
                    />
                  }
                  color="primary"
                  label={<FormattedMessage id="LbRead" defaultMessage="Read" />}
                  tabIndex="12"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      id="LbSpeak"
                      checked={this.state.speak}
                      onChange={this.UpdateLanguageDetails("speak")}
                      value={this.state.speak}
                      classes={{
                        root: classes.root,
                        checked: classes.checked,
                      }}
                      color="primary"
                    />
                  }
                  color="primary"
                  label={
                    <FormattedMessage id="LbSpeak" defaultMessage="Speak" />
                  }
                  tabIndex="13"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      id="LbWrite"
                      checked={this.state.write}
                      onChange={this.UpdateLanguageDetails("write")}
                      value={this.state.write}
                      classes={{
                        root: classes.root,
                        checked: classes.checked,
                      }}
                      color="primary"
                    />
                  }
                  color="primary"
                  label={
                    <FormattedMessage id="LbWrite" defaultMessage="Write" />
                  }
                  tabIndex="14"
                />
              </div>
            </div>
            <div className="upform-footer">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="form-btn save"
                onClick={this.AddLanguages.bind(this)}
              >
                <FormattedMessage id="BtSave" defaultMessage="Save" />
              </Button>
              <span className="margin-left-16">
                <Button
                  id="Cancel"
                  size="large"
                  className={classes.button}
                  onClick={() =>
                    this.setState({
                      flag: this.state.languages.length < 1 ? 0 : 1,
                    })
                  }
                >
                  <FormattedMessage id="BtCancel" defaultMessage="CANCEL" />
                </Button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const { flag, languages, received, fluencyid, dataReceived } = this.state;
    return (
      <div>
        <If condition={dataReceived}>
          <If condition={flag == 0}>{this.getIntroView()}</If>
          <If condition={flag == 1}>{this.getDataView(languages)}</If>
          <If condition={flag == 2}>{this.getFormView(fluencyid)}</If>
        </If>
      </div>
    );
  }
}

export default withSnackbar(EmpLanguage);
